/* eslint-disable */
/**
 * This client was automatically generated by Segment Typewriter. ** Do Not Edit **
 */
/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler = (message, violations) => {
  const msg = JSON.stringify(
    {
      type: 'Typewriter JSON Schema Validation Error',
      description:
        `You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
        'Tracking Plan spec.',
      errors: violations,
    },
    undefined,
    2
  );
  console.warn(msg);
};
let analytics = () => {
  return window.analytics;
};
/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options) {
  analytics = options.analytics
    ? () => options.analytics || window.analytics
    : analytics;
}
/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message = {}) {
  return {
    ...message,
    context: {
      ...(message.context || {}),
      typewriter: {
        language: 'javascript',
        version: '7.4.1',
      },
    },
  };
}
/**
 * @typedef AccountActivated
 * @property {number} [noninteraction] -
 */
/**
 * @typedef AccountModalOpened
 * @property {string} [modal_id] - ID of the modal which was opened

 */
/**
 * @typedef AccountSetupError
 * @property {string} [error_code] - error code for account setup error
 */
/**
 * @typedef AddressError
 * @property {string} [error_code] -
 */
/**
 * @typedef AddressGeocoded
 * @property {number} [noninteraction] -
 * @property {string} [region_code] -
 * @property {string} [region_name] -
 */
/**
 * @typedef CheckingCoverage
 * @property {string} [agent_id] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 */
/**
 * @typedef CheckoutStarted
 * @property {string} [lob] -
 * @property {string} [order_id] -
 * @property {string} [plan_id] -
 * @property {Record<string, any>} [quantity] -
 * @property {string} [quote_number] -
 * @property {number} [revenue] -
 * @property {number} [value] -
 */
/**
 * @typedef CompleteRegistration
 * @property {string} [currency] -
 */
/**
 * @typedef CoverageStartDateSubmitted
 * @property {string} [agent_id] -
 * @property {Record<string, any>} [days_ahead] -
Number of days from current
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 */
/**
 * @typedef CoverageStartDateUpdated
 * @property {string} [agent_id] -
 * @property {string} [category] -
 * @property {string} [label] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 * @property {number} [value] -
 */
/**
 * @typedef CtaClicked
 * @property {string} [agent_id] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 * @property {string} [value] -
 */
/**
 * @typedef DocumentSigned
 * @property {string} [document_name] -
 * @property {string} [document_type] - name of document signed
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 */
/**
 * @typedef EditCoverageConfirmed
 * @property {string} [agent_id] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 * @property {number} [value] - current full term premium after coverage changes
 */
/**
 * @typedef FactorSubmitted
 * @property {string} [type] - MFA factor types
 */
/**
 * @typedef FinalizeQuoteFailed
 * @property {string} [error_code] -
 * @property {number} [noninteraction] -
 */
/**
 * @typedef GetAQuoteSubmitted
 * @property {string} [agent_id] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 */
/**
 * @typedef HelpShown
 * @property {Record<string, any>} [category] -
 * @property {string} [name] -
 */
/**
 * @typedef Lead
 * @property {string} [currency] -
 */
/**
 * @typedef LogInFailed
 * @property {number} [noninteraction] -
 */
/**
 * @typedef LogInSucceeded
 * @property {number} [noninteraction] -
 */
/**
 * @typedef OrderCompleted
 * @property {string} [category] -
 * @property {string} [currency] -
 * @property {string} [lob] -
 * @property {number} [noninteraction] -
 * @property {string} [order_id] -
 * @property {string} [plan_id] -
 * @property {string} [product_id] -
 * @property {number} [quantity] -
 * @property {string} [quote_number] -
 * @property {number} [revenue] -
 * @property {number} [total] -
 */
/**
 * @typedef PageViewed
 * @property {string} [path] -
 * @property {string} [referrer] -
 * @property {string} [search] -
 * @property {string} [title] -
 * @property {string} [url] -
 */
/**
 * @typedef PaymentMethodCreated
 * @property {string} [lob] -
 * @property {number} [noninteraction] -
 * @property {string} [quote_number] -
 */
/**
 * @typedef PaymentTermSelected
 * @property {string} [term] -
 */
/**
 * @typedef QuoteLinkSent
 * @property {string} [agent_id] -
 * @property {string} [email] -
 * @property {string} [first_name] -
 * @property {string} [last_name] -
 * @property {string} [quote_link] -
 * @property {string} [quote_number] -
 */
/**
 * @typedef QuoteRequested
 * @property {string} [agent_id] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 * @property {string} [region_code] -
 * @property {string} [region_name] -
 */
/**
 * @typedef Coverage
 * @property {string} [title] -
 * @property {string} [value] -
 */
/**
 * @typedef PhasedRegistrationNames
 * @property {string} [bubbled] -
 * @property {string} [captured] -
 */
/**
 * @typedef UpdatedValue
 * @property {string[]} [dependencies] -
 * @property {string} [driver_id] -
 * @property {PhasedRegistrationNames} [phasedRegistrationNames] -
 * @property {string} [vehicle_id] -
 */
/**
 * @typedef PhasedRegistrationNames1
 * @property {string} [bubbled] -
 * @property {string} [captured] -
 */
/**
 * @typedef Value
 * @property {string[]} [dependencies] -
 * @property {PhasedRegistrationNames1} [phasedRegistrationNames] -
 */
/**
 * @typedef QuoteVariableAdjusted
 * @property {number} [adjusted_price] -
 * @property {string} [agent_id] -
 * @property {string} [category] -
 * @property {Coverage} [coverage] -
 * @property {string} [key] -
 * @property {string} [label] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 * @property {UpdatedValue} [updated_value] -
 * @property {Value} [value] -
 */
/**
 * @typedef QuotingFailed
 * @property {string} [agent_id] -
 * @property {string} [error_code] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 */
/**
 * @typedef ReminderClicked
 * @property {string} [key] -
 */
/**
 * @typedef ReminderDismissed
 * @property {string} [key] -
 */
/**
 * @typedef ReportNotFound
 * @property {string} [agent_id] -
 * @property {string} [error_code] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 */
/**
 * @typedef SignUpInfoSubmitted
 * @property {string} [agent_id] -
 * @property {boolean} [has_previous_address] -
 * @property {string} [lob] -
 * @property {string} [quote_number] -
 */
/**
 * @typedef StripeTokenCreated
 * @property {string} [lob] -
 * @property {number} [noninteraction] -
 * @property {string} [quote_number] -
 */
/**
 * Tracking Okta account activation success
 *
 * @param {AccountActivated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountActivated(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Account Activated',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 *
Track logged in customer account settings modals interactions
 *
 * @param {AccountModalOpened} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountModalOpened(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Account Modal Opened',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Track account setup errors

 *
 * @param {AccountSetupError} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountSetupError(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Account Setup Error',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Track errors associated with address submission events
 *
 * @param {AddressError} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addressError(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Address Error',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Detect successfully geocoded address submissions
 *
 * @param {AddressGeocoded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addressGeocoded(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Address Geocoded',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking the submission of an address across different flows that require it

 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addressSubmitted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Address Submitted',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking API progress before moving to the next step in the quote or edit flows.
 *
 * @param {CheckingCoverage} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkingCoverage(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Checking Coverage',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking how many customers submit their payment

 *
 * @param {CheckoutStarted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutStarted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Checkout Started',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * e-Commerce spec for registration complete
 *
 * @param {CompleteRegistration} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function completeRegistration(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'CompleteRegistration',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking the coverage start date
 *
 * @param {CoverageStartDateSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function coverageStartDateSubmitted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Coverage Start Date Submitted',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking the edits to the coverage start date
 *
 * @param {CoverageStartDateUpdated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function coverageStartDateUpdated(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Coverage Start Date Updated',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Call to Action click events
 *
 * @param {CtaClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function ctaClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Cta Clicked',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking the signing ceremony progress
 *
 * @param {DocumentSigned} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function documentSigned(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Document Signed',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Confirmation of a successful Edit Coverage action
 *
 * @param {EditCoverageConfirmed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function editCoverageConfirmed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Edit Coverage Confirmed',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking the final submission of Edit Coverage actions
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function editCoverageSubmitted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Edit Coverage Submitted',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Fires a 'Experiment Viewed' track call.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function experimentViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Experiment Viewed',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * rack the MFA submission events for Okta - This has been renamed from SMS Factor Submitted. Properties will be used
 *
 * @param {FactorSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function factorSubmitted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Factor Submitted',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Track errors on purchase attempts
 *
 * @param {FinalizeQuoteFailed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function finalizeQuoteFailed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Finalize Quote Failed',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * How many customers submit their information for a quote
 *
 * @param {GetAQuoteSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function getAQuoteSubmitted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Get A Quote Submitted',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * How many customers interact with the help prompts, modals and snackbars
 *
 * @param {HelpShown} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function helpShown(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Help Shown',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Track standard landing page event, commonly used by FB
 *
 * @param {Lead} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function lead(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Lead', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * Track customer login failures
 *
 * @param {LogInFailed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function logInFailed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Log In Failed',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Track customer login successes
 *
 * @param {LogInSucceeded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function logInSucceeded(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Log In Succeeded',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Address and IID logic event
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function matchUnavailable(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Match Unavailable',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Standard e-Commerce event for completed purchase
 *
 * @param {OrderCompleted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function orderCompleted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Order Completed',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Standard Tack for Page Views
 *
 * @param {PageViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pageViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Page Viewed',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Track the purchase API progress
 *
 * @param {PaymentMethodCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function paymentMethodCreated(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Payment Method Created',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Fires a 'Payment Term Selected' track call.
 *
 * @param {PaymentTermSelected} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function paymentTermSelected(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Payment Term Selected',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Fires a 'Quote Link Sent' track call.
 *
 * @param {QuoteLinkSent} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quoteLinkSent(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Quote Link Sent',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking the start of the quote flow
 *
 * @param {QuoteRequested} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quoteRequested(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Quote Requested',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking changes to coverage during the purchase and edit flows
 *
 * @param {QuoteVariableAdjusted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quoteVariableAdjusted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Quote Variable Adjusted',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * We can see how many customers encounter an error after submitting their information
 *
 * @param {QuotingFailed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function quotingFailed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Quoting Failed',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking reminder engagement
 *
 * @param {ReminderClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function reminderClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Reminder Clicked',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Tracking reminder engagement
 *
 * @param {ReminderDismissed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function reminderDismissed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Reminder Dismissed',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Output of reports that are un-available or did not match
 *
 * @param {ReportNotFound} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function reportNotFound(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Report Not Found',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Output of reports that are un-available or did not match
 *
 * @param {SignUpInfoSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signUpInfoSubmitted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Sign Up Info Submitted',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * Track the purchase API progress
 *
 * @param {StripeTokenCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function stripeTokenCreated(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Stripe Token Created',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
/**
 * To Track views and build funnels off of the self service portal
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function viewedMyCoveragePage(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track(
      'Viewed My Coverage Page',
      props || {},
      withTypewriterContext(options),
      callback
    );
  }
}
const clientAPI = {
  /**
   * Updates the run-time configuration of this Typewriter client.
   *
   * @param {TypewriterOptions} options - the options to upsert
   *
   * @typedef {Object} TypewriterOptions
   * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setTypewriterOptions,
  /**
   * Tracking Okta account activation success
   *
   * @param {AccountActivated} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  accountActivated,
  /**
     *
    Track logged in customer account settings modals interactions
     *
     * @param {AccountModalOpened} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
  accountModalOpened,
  /**
     * Track account setup errors
    
     *
     * @param {AccountSetupError} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
  accountSetupError,
  /**
   * Track errors associated with address submission events
   *
   * @param {AddressError} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  addressError,
  /**
   * Detect successfully geocoded address submissions
   *
   * @param {AddressGeocoded} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  addressGeocoded,
  /**
     * Tracking the submission of an address across different flows that require it
    
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
  addressSubmitted,
  /**
   * Tracking API progress before moving to the next step in the quote or edit flows.
   *
   * @param {CheckingCoverage} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  checkingCoverage,
  /**
     * Tracking how many customers submit their payment
    
     *
     * @param {CheckoutStarted} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
  checkoutStarted,
  /**
   * e-Commerce spec for registration complete
   *
   * @param {CompleteRegistration} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  completeRegistration,
  /**
   * Tracking the coverage start date
   *
   * @param {CoverageStartDateSubmitted} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  coverageStartDateSubmitted,
  /**
   * Tracking the edits to the coverage start date
   *
   * @param {CoverageStartDateUpdated} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  coverageStartDateUpdated,
  /**
   * Call to Action click events
   *
   * @param {CtaClicked} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  ctaClicked,
  /**
   * Tracking the signing ceremony progress
   *
   * @param {DocumentSigned} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  documentSigned,
  /**
   * Confirmation of a successful Edit Coverage action
   *
   * @param {EditCoverageConfirmed} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  editCoverageConfirmed,
  /**
   * Tracking the final submission of Edit Coverage actions
   *
   * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  editCoverageSubmitted,
  /**
   * Fires a 'Experiment Viewed' track call.
   *
   * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  experimentViewed,
  /**
   * rack the MFA submission events for Okta - This has been renamed from SMS Factor Submitted. Properties will be used
   *
   * @param {FactorSubmitted} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  factorSubmitted,
  /**
   * Track errors on purchase attempts
   *
   * @param {FinalizeQuoteFailed} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  finalizeQuoteFailed,
  /**
   * How many customers submit their information for a quote
   *
   * @param {GetAQuoteSubmitted} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  getAQuoteSubmitted,
  /**
   * How many customers interact with the help prompts, modals and snackbars
   *
   * @param {HelpShown} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  helpShown,
  /**
   * Track standard landing page event, commonly used by FB
   *
   * @param {Lead} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  lead,
  /**
   * Track customer login failures
   *
   * @param {LogInFailed} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  logInFailed,
  /**
   * Track customer login successes
   *
   * @param {LogInSucceeded} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  logInSucceeded,
  /**
   * Address and IID logic event
   *
   * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  matchUnavailable,
  /**
   * Standard e-Commerce event for completed purchase
   *
   * @param {OrderCompleted} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  orderCompleted,
  /**
   * Standard Tack for Page Views
   *
   * @param {PageViewed} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  pageViewed,
  /**
   * Track the purchase API progress
   *
   * @param {PaymentMethodCreated} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  paymentMethodCreated,
  /**
   * Fires a 'Payment Term Selected' track call.
   *
   * @param {PaymentTermSelected} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  paymentTermSelected,
  /**
   * Fires a 'Quote Link Sent' track call.
   *
   * @param {QuoteLinkSent} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  quoteLinkSent,
  /**
   * Tracking the start of the quote flow
   *
   * @param {QuoteRequested} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  quoteRequested,
  /**
   * Tracking changes to coverage during the purchase and edit flows
   *
   * @param {QuoteVariableAdjusted} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  quoteVariableAdjusted,
  /**
   * We can see how many customers encounter an error after submitting their information
   *
   * @param {QuotingFailed} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  quotingFailed,
  /**
   * Tracking reminder engagement
   *
   * @param {ReminderClicked} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  reminderClicked,
  /**
   * Tracking reminder engagement
   *
   * @param {ReminderDismissed} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  reminderDismissed,
  /**
   * Output of reports that are un-available or did not match
   *
   * @param {ReportNotFound} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  reportNotFound,
  /**
   * Output of reports that are un-available or did not match
   *
   * @param {SignUpInfoSubmitted} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  signUpInfoSubmitted,
  /**
   * Track the purchase API progress
   *
   * @param {StripeTokenCreated} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  stripeTokenCreated,
  /**
   * To Track views and build funnels off of the self service portal
   *
   * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  viewedMyCoveragePage,
};
export const defaultProxy = new Proxy(clientAPI, {
  get(target, method) {
    if (typeof method === 'string' && target.hasOwnProperty(method)) {
      return target[method];
    }
    return () => {
      console.warn(`⚠️  You made an analytics call (${String(
        method
      )}) that can't be found. Either:
    a) Re-generate your typewriter client: \`npx typewriter\`
    b) Add it to your Tracking Plan: https://app.segment.com/gettoggle/protocols/tracking-plans/rs_1clabljcXc9KXB9XES15Gt8bMT3`);
      const a = analytics();
      if (a) {
        a.track(
          'Unknown Analytics Call Fired',
          {
            method,
          },
          withTypewriterContext()
        );
      }
    };
  },
});

export default new Proxy(clientAPI, {
  get(target, method) {
    if (typeof method === 'string' && target.hasOwnProperty(method)) {
      return target[method];
    }
    return () => {
      console.warn(
        `⚠️  You made an analytics call (${String(
          method
        )}) that can't be found. This event was NOT reported to the server.`
      );
    };
  },
});
